// global module
export const GET_DEALER_MICRO_SITE = "GET_DEALER_MICRO_SITE";

// search module
export const GET_DATA_FROM_API = "GET_DATA_FROM_API";
export const GET_MAX_PRICE_RANGE = "GET_MAX_PRICE_RANGE";
export const UPDATE_REGIONS_LIST = "UPDATE_REGIONS_LIST";

// results module
export const GET_MORE_CARS = "GET_MORE_CARS";

// details module
export const GET_INFO_ABOUT_CAR = "GET_INFO_ABOUT_CAR";
